import axios from "axios";

export default {
  getRoles() {
    const tokenAuth = localStorage.getItem("access_token");
    const headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get("api/roles", headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
};
